/**
 * PostIcon — displays the icon for an assigned post.
 *
 * Three rendering paths:
 *   - Break       → ☕ emoji on tan background
 *   - Known post  → image from assets.getPostIcon()
 *   - Unknown     → 📍 emoji fallback
 */
import { getPostIcon } from '../../assets'

interface PostIconProps {
  post: string
  isBreak: boolean
  size?: number
}

export default function PostIcon({ post, isBreak, size = 40 }: PostIconProps) {
  if (isBreak || post === 'Break') {
    return (
      <span
        style={{
          fontSize: 24,
          width: size,
          height: size,
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: '#e5ad76',
          borderRadius: 4,
        }}
      >
        ☕
      </span>
    )
  }

  const src = getPostIcon(post)
  if (src) {
    return (
      <img
        src={src}
        alt={post}
        style={{ width: size, height: size, borderRadius: 4 }}
      />
    )
  }

  return (
    <span
      style={{
        fontSize: 24,
        width: size,
        height: size,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      📍
    </span>
  )
}
